// ReadingPassage — long-form English reading + linked comprehension questions.
// Per LLM_NATIVE_ARCHITECTURE.md §10 + 陛下 19AN: "雅思可以忽略，只是规划为
// 英语，我们后期可以专门给雅思开发个模板，但可以先用英语来代替".
//
// Generic English reading container. NOT specialized for IELTS / TOEFL /
// 考研 — those are future templates. Ships with two question linking modes:
//
//   - questionRefs[]: cross-links to existing mcq / trueFalse ids (preferred —
//     reuses the existing MCQ / TF schemas + render path). The LLM generates
//     standard MCQ / TF items and tags them via topicId / passageId.
//
// (Future: in-passage cloze blanks, matching headings, sentence completion
//  would require new question kinds — defer until needed.)
//
// 19BH Day 2 Step 2.4: ItemTags base applied. v3 had caseId (required string).
// v4 uses caseIds[] · crossChapterAllowed=true per MANIFEST (passages may span
// chapter topics). Singular caseId stays as deprecated optional alias.
import { z } from 'zod';
import { ItemTagsSchema, coerceItemTagsV3ToV4 } from './item-tags.js';
import { ConceptOmissionSchema } from './concept-omission.js';
export const ReadingPassageSchema = z.preprocess(coerceItemTagsV3ToV4, ItemTagsSchema.extend({
    id: z.string().regex(/^rp[a-z0-9_-]+$/, 'reading-passage id must start with "rp"')
        .describe('Unique snake_case slug starting with `rp` (e.g. `rp_globalization_01`).'),
    /** @deprecated v3 alias of caseIds[0]. */
    caseId: z.string().min(1).nullable().optional()
        .describe('@deprecated v3 alias of caseIds[0]. Use caseIds[].'),
    title: z.string().min(1).max(120)
        .describe('Short title shown in sidebar / header.'),
    passage: z.string().min(600)
        .describe('The reading text itself, 300-800 words (~600-4000 chars). ≥600 chars (lower bound for a coherent passage · was min 1 — Session 19AO). Markdown. Maintains authentic register (academic / journalistic) and stays within source-material scope.'),
    /** Cross-references to mcq / trueFalse items the LLM also generated for
     *  this passage. Render path: passage on left, question list on right; user
     *  reads then answers. */
    questionRefs: z.array(z.string().min(1)).min(1)
        .describe('Ordered ids of mcq / trueFalse items linked to this passage. Must resolve to items in IngestPackage.mcqs / .trueFalse with caseId === this.caseId.'),
    /** Optional source attribution (when passage is paraphrased from a real
     *  text — academic norm). Free-form string. */
    sourceCredit: z.string().optional(),
    /** Approximate word count (UI displays "~N words"). */
    wordCount: z.number().int().positive().optional(),
    omittedConcepts: z.array(ConceptOmissionSchema).nullish()
        .describe('K18 soft escape · concepts the LLM declared materially insufficient for this stage. Reading passage MANIFEST entry has acceptsOmissionReason=false (passage is coherent unit) but field stays in schema for uniform shape.'),
}).passthrough());
//# sourceMappingURL=reading-passage.js.map